import { CapabilityKey, SubCapabilityKey, useApplicationCapabilitiesAllowed } from "@next-platform/client-common-core/infra/application/capabilities";

import resolveShouldFilterNsfwCharacters from "@/components/search/utils/shouldFilterNsfwCharacters";

interface IUseShouldFilterNsfwCharactersParameters {
  isNsfwToggled: boolean;
  isShowNsfwEnabled: boolean;
}

interface IUseShouldFilterNsfwCharactersResult {
  isEffectiveNsfwToggleEnabled: boolean;
  isNsfwCharacterDiscoveryAllowed: boolean;
  isNsfwToggleAllowed: boolean;
  shouldFilterNsfwCharacters: boolean;
}

const useShouldFilterNsfwCharacters = ({
  isNsfwToggled,
  isShowNsfwEnabled,
}: IUseShouldFilterNsfwCharactersParameters): IUseShouldFilterNsfwCharactersResult => {
  const isNsfwEnabled = useApplicationCapabilitiesAllowed(CapabilityKey.Nsfw);
  const [isNsfwCharacterDiscoveryAllowed, isNsfwToggleAllowed] = useApplicationCapabilitiesAllowed([
    SubCapabilityKey.NsfwCharacterDiscovery,
    SubCapabilityKey.NsfwUserToggle,
  ]);
  const isEffectiveNsfwToggleEnabled = isNsfwCharacterDiscoveryAllowed && isNsfwToggled;
  const shouldFilterNsfwCharacters = resolveShouldFilterNsfwCharacters({
    isNsfwCharacterDiscoveryAllowed,
    isNsfwEnabled,
    isNsfwToggleAllowed,
    isNsfwToggled: isEffectiveNsfwToggleEnabled,
    isShowNsfwEnabled,
  });

  return {
    isEffectiveNsfwToggleEnabled,
    isNsfwCharacterDiscoveryAllowed,
    isNsfwToggleAllowed,
    shouldFilterNsfwCharacters,
  };
};

export default useShouldFilterNsfwCharacters;
